/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    '3gBSLYpZKDFTE1YrNBBLbM.png': { uri: '/images/3gBSLYpZKDFTE1YrNBBLbM.png' },
'54gTEEL2wXboZhURdzyXta.png': { uri: '/images/54gTEEL2wXboZhURdzyXta.png' },
'b8bNk1yzGGk2NagUMBTgKh.png': { uri: '/images/b8bNk1yzGGk2NagUMBTgKh.png' },
'pqDjX3wqFRQPnkK6qitXYy.png': { uri: '/images/pqDjX3wqFRQPnkK6qitXYy.png' },
'dsh5KujWUW2jXouZ2UtBRA.png': { uri: '/images/dsh5KujWUW2jXouZ2UtBRA.png' },
'cyEa6BuVobF3uYrWDxg5oZ.png': { uri: '/images/cyEa6BuVobF3uYrWDxg5oZ.png' },
'kWuLWcZJ74xHgZndZbXSQo.png': { uri: '/images/kWuLWcZJ74xHgZndZbXSQo.png' },
'87GTKx4aR6nNthMqX7yRe9.png': { uri: '/images/87GTKx4aR6nNthMqX7yRe9.png' },
'qX2kjERwQ8GXJuVu99itw4.png': { uri: '/images/qX2kjERwQ8GXJuVu99itw4.png' },
'rXSJj1QF5eXvwdPRuCTb6A.png': { uri: '/images/rXSJj1QF5eXvwdPRuCTb6A.png' },
'utiPozsPJfEaYEcP6UZnz5.png': { uri: '/images/utiPozsPJfEaYEcP6UZnz5.png' },
'2iSqSoBLp2eVq28de7F8Aq.png': { uri: '/images/2iSqSoBLp2eVq28de7F8Aq.png' },
'6SssFAFKwkJGZCJrY1hCPL.png': { uri: '/images/6SssFAFKwkJGZCJrY1hCPL.png' },
'dhtaYcZGEeKzkkR43xE3CA.png': { uri: '/images/dhtaYcZGEeKzkkR43xE3CA.png' },
'twBRiUwYcSovJqf1qtJWAv.webp': { uri: '/images/twBRiUwYcSovJqf1qtJWAv.webp' },
'tnEgRojLht3oRZPnbp7qFC.png': { uri: '/images/tnEgRojLht3oRZPnbp7qFC.png' },
'pwKZpfae8QUNxAMT3z7A3k.png': { uri: '/images/pwKZpfae8QUNxAMT3z7A3k.png' },
'sKNjasrLYttHYgB95WmMPE.png': { uri: '/images/sKNjasrLYttHYgB95WmMPE.png' },
'oPrttKxcCGGnrpRAFNQSdk.png': { uri: '/images/oPrttKxcCGGnrpRAFNQSdk.png' },
'azc62MJdbFVApFv6Gkb165.png': { uri: '/images/azc62MJdbFVApFv6Gkb165.png' },
'kLbsx55p5h3jsg6RpTw2zp.png': { uri: '/images/kLbsx55p5h3jsg6RpTw2zp.png' },
'9oXMEKe6TYUumyVKZmtgWq.png': { uri: '/images/9oXMEKe6TYUumyVKZmtgWq.png' },
'mmigjuRMFTG8YYDNjdtjRx.png': { uri: '/images/mmigjuRMFTG8YYDNjdtjRx.png' },
'bLsRtH4hEmDiWreQ4bADh5.png': { uri: '/images/bLsRtH4hEmDiWreQ4bADh5.png' },
'syP6cinfSNDNLQjSkFEyXH.png': { uri: '/images/syP6cinfSNDNLQjSkFEyXH.png' },
'qXCnXHdBFcfdaMMPfUFQtb.png': { uri: '/images/qXCnXHdBFcfdaMMPfUFQtb.png' },
'2T2skgbGo1KCJKBBeqDbrm.png': { uri: '/images/2T2skgbGo1KCJKBBeqDbrm.png' },
'aDGG9sAUfQg6YtswNbvyWq.png': { uri: '/images/aDGG9sAUfQg6YtswNbvyWq.png' },
'iEXjdM7uMDS3yS8bWYzkdB.png': { uri: '/images/iEXjdM7uMDS3yS8bWYzkdB.png' },
'xqt5W9c3wjoDDKnxAv31aM.png': { uri: '/images/xqt5W9c3wjoDDKnxAv31aM.png' },
'rFsPTTrzxwCHdaZ1m2zxY8.png': { uri: '/images/rFsPTTrzxwCHdaZ1m2zxY8.png' },
'8M3JiM8hCXoqWFeYN4v6KH.png': { uri: '/images/8M3JiM8hCXoqWFeYN4v6KH.png' },
'dvuMscRgVX1Lfi6zCDPkyb.png': { uri: '/images/dvuMscRgVX1Lfi6zCDPkyb.png' },
'f97VrBFRo958Ex7a3SuNqf.png': { uri: '/images/f97VrBFRo958Ex7a3SuNqf.png' },
'ez7Ybb6LE1cnFFn1vgMDjF.png': { uri: '/images/ez7Ybb6LE1cnFFn1vgMDjF.png' },
'mAUcHmnVGtxjYc2svJf56H.png': { uri: '/images/mAUcHmnVGtxjYc2svJf56H.png' },
'ii5vx5URqYHr4zha6ukK2k.png': { uri: '/images/ii5vx5URqYHr4zha6ukK2k.png' },
'cmRFwAZWE57a77ZwoVrpM7.png': { uri: '/images/cmRFwAZWE57a77ZwoVrpM7.png' }
}

export default imageStaticSourcesByFileName
